import { useEffect, useState } from 'react';
import { imageCacheService } from '../../../services/ImageCacheService';

export const useCachedImage = (url: string | undefined) => {
    const [imageSource, setImageSource] = useState<{ uri: string } | number | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!url) {
            setImageSource(require('../../../assets/no-image.png'));
            setIsLoading(false);
            return;
        }

        let isMounted = true;

        // Get cached image or fetch and cache
        imageCacheService.getCachedImage(url)
            .then(cachedUrl => {
                if (isMounted) {
                    setImageSource({ uri: cachedUrl });
                    setIsLoading(false);
                }
            })
            .catch(err => {
                console.warn('⚠️ Failed to load image:', err);
                if (isMounted) {
                    // Fallback to original URL
                    setImageSource({ uri: url });
                    setIsLoading(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [url]);

    return { imageSource, isLoading };
};

